import { LostChangesReport } from 'src/core/presence/domain/lost-changes-report';

export abstract class LostChangesReporter {
  abstract report(report: LostChangesReport): void;
}
